import React from 'react'
import { ListIconBox as OriginalListIconBox } from '@next-nx/shared-ui/organisms'
import { ListIconBoxSettings } from './ListIconBoxSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {}

export const ListIconBox = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const {} = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-list-icon-box ' + props.className}
      >
        <OriginalListIconBox
          items={children.props?.children || []}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

ListIconBox.craft = withCraft({
  name: 'ListIconBox',
  defaultProps: defaultProps,
  settings: ListIconBoxSettings,
});
